"use client";

import { useRouter, useSearchParams, usePathname } from "next/navigation";

export function useResetPageToOne() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const resetPageToOne = () => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", "1");
    router.push(`${pathname}?${params.toString()}`);
  };

  return resetPageToOne;
}
